import { SocketEvent } from "../SocketEvent";
import { SocketEventInterface } from "../SocketEventInterface";
import { SocketEventProcessorInterface } from "../SocketEventProcessorInterface";
import Constants from "../../Action/Constants";
import PropertyFactory from "../../Entity/Factories/PropertyFactory";
import { PropertyInterface } from "../../Entity/Entities/Property/PropertyInterface";

class PropertyCreate extends SocketEvent implements SocketEventInterface {

  protected props: any;

  constructor() {
    super();
  }

  public process(props: SocketEventProcessorInterface): void {
    const property: PropertyInterface = PropertyFactory.create(props.res);

    this.props.dispatch({
      type: Constants.PAGE_PROPERTY_CREATE_SUCCESS,
      payload: {
        property: property
      }
    });
  }

}

export { PropertyCreate };
